var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "c-summary-view" }, [
    _c("div", { staticClass: "c-summary-view_container c-view-container" }, [
      _c("div", { staticClass: "c-view-container__inner" }, [
        _c(
          "div",
          { staticClass: "c-summary-view_content-col c-view-content-col" },
          [
            _c("div", { staticClass: "c-view-content-col__inner" }, [
              _c("h2", { staticClass: "c-summary-view__heading" }, [
                _vm._v("Your savings"),
              ]),
              _vm._v(" "),
              _c(
                "h2",
                {
                  staticClass:
                    "c-summary-view__heading c-summary-view__heading--green",
                },
                [
                  _vm._v(
                    "\n            $" +
                      _vm._s(_vm.getAnnualSavingsTotal) +
                      "\n          "
                  ),
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "c-view-summary__save-area" }, [
                _c("img", {
                  staticClass: "c-view-summary__save-area-image",
                  attrs: {
                    src: "_resources/app/client/assets/images/answer-green.svg",
                    alt: "answer icon",
                  },
                }),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "c-view-summary__save-area-text" },
                  [
                    _c("div", {
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.Summary.SummaryViewEmailSaveForLater
                        ),
                      },
                    }),
                    _vm._v(" "),
                    _c("EmailYourSavingsButton"),
                  ],
                  1
                ),
              ]),
            ]),
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "c-summary-view_right-col" }, [
          _c("div", { staticClass: "c-summary-view-receipt" }, [
            _c("img", {
              staticClass: "c-summary-view-receipt__logo",
              attrs: {
                src: "_resources/app/client/assets/images/we-letters-logo.svg",
                alt: "WE logo",
              },
            }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "c-summary-view-receipt__items" },
              _vm._l(_vm.getAnnualSavingsResults, function (result) {
                return _c(
                  "div",
                  {
                    key: result.category,
                    staticClass: "c-summary-view-receipt__item-category",
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "c-summary-view-receipt__item-category-heading",
                      },
                      [
                        _vm._v(
                          "\n                " +
                            _vm._s(result.category) +
                            "\n              "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _vm._l(result.answers, function (answer) {
                      return _c(
                        "div",
                        {
                          key: answer.QuestionSummaryText,
                          staticClass: "c-summary-view-receipt__item-answer",
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "c-summary-view-receipt__item-answer-heading",
                            },
                            [
                              _vm._v(
                                "\n                  " +
                                  _vm._s(answer.QuestionSummaryText) +
                                  "\n                "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          answer.SavingsAmountMultiplierApplied != null
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "c-summary-view-receipt__item-answer-saving",
                                },
                                [
                                  _vm._v(
                                    "\n                  $" +
                                      _vm._s(
                                        answer.SavingsAmountMultiplierApplied
                                      ) +
                                      " p/year\n                "
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ]
                      )
                    }),
                  ],
                  2
                )
              }),
              0
            ),
            _vm._v(" "),
            _c("div", { staticClass: "c-summary-view-receipt__total" }, [
              _vm._m(0),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "c-summary-view-receipt__total-right" },
                [
                  _c(
                    "p",
                    { staticClass: "c-summary-view-receipt__total-amount" },
                    [
                      _vm._v(
                        "\n                $" +
                          _vm._s(_vm.getAnnualSavingsTotal) +
                          "\n              "
                      ),
                    ]
                  ),
                ]
              ),
            ]),
          ]),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "c-view-controls__wrapper" }, [
      _c("div", { staticClass: "c-view-controls" }, [
        _c("div", { staticClass: "c-view-controls__inner" }, [
          _c(
            "button",
            {
              staticClass: "u-calc-button u-calc-button--prev",
              on: { click: _vm.prev },
            },
            [_c("span"), _vm._v(" "), _c("p", [_vm._v("Previous")])]
          ),
          _vm._v(" "),
          _c(
            "button",
            { staticClass: "u-calc-button", on: { click: _vm.finish } },
            [_c("span"), _vm._v(" "), _c("p", [_vm._v("Finish")])]
          ),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "c-summary-view-receipt__total-left" }, [
      _c("p", { staticClass: "c-summary-view-receipt__total-heading" }, [
        _vm._v("\n                **** Total ****\n              "),
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "c-summary-view-receipt__total-subheading" }, [
        _vm._v("\n                *Potential power savings\n              "),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }